import {  PLAYOFF_VS_LIST_ACTION } from 'core/constants/Actions';
import { Action } from 'core/models/ActionTypes'
import { PrizeConfig, Result, TournamentDetails } from 'core/models/Tournament';

const initialState: {
  isLoading: boolean,
  rewarded: boolean,
  tournamentCompleted: boolean,
  winnerTeams: Result[],
  prizeConfig: PrizeConfig[]
  tournamentDetails : TournamentDetails;
} = {
  rewarded: false,
  tournamentCompleted: false,
  prizeConfig: [],
  winnerTeams: [],
  isLoading: false,
  tournamentDetails : {
    id : "",
    title: '',
    content : {
      banner: '',
      icon: ''
    },
    currency :""
  }
}

interface ActionType extends Action {
  payload: {
    rewarded: boolean;
    tournamentCompleted: boolean;
    winnerTeams: Result[];
    prizeConfig: PrizeConfig[];
    tournamentDetails : TournamentDetails;
  }
}

export default function playoffVsRoundsReducer(state = initialState, action: ActionType) {

  switch (action.type) {
    case PLAYOFF_VS_LIST_ACTION.REQUEST:
      return { ...state, isLoading: true }

    case PLAYOFF_VS_LIST_ACTION.SUCCESS:
      const {  prizeConfig, rewarded, tournamentCompleted, winnerTeams ,tournamentDetails} = action.payload;
      return { ...state, prizeConfig, rewarded, tournamentCompleted, winnerTeams, isLoading: false ,tournamentDetails }

    case PLAYOFF_VS_LIST_ACTION.FAILURE:
      return { ...state, ...initialState }

    default:
      return state
  }
}